/**
 * crop-cycle-map.ts — D16: un target cuyo último ciclo está CERRADO conserva su cultivo y
 * el mapa lo pinta atenuado ("último ciclo cerrado") solo en la fecha de hoy; en fechas
 * pasadas el slider lee ModuleCropHistory y no se atenúa.
 */
export function isClosedCycleLook(
  item: { cropId?: string; cropCycleStatus?: 'OPEN' | 'CLOSED' },
  selectedDate: string,
  today: string,
): boolean {
  return selectedDate === today && !!item.cropId && item.cropCycleStatus === 'CLOSED';
}
